// extracted by mini-css-extract-plugin
export default {"tooltip":"uW-z","arrow":"vW-z"};